<template>
    <div class="flex flex-wrap">
        <span
            v-for="entry in entries"
            :key="entry.label"
            class="sim-line-separated-list"
        >
            {{ `${entry.label}: ${entry.value}` }}
        </span>
    </div>
</template>

<script lang="ts" setup>
import type { VariationPropertyEntry } from '@simploshop-models/cart-item.model'

const {
    entries,
} = defineProps<{
    entries: VariationPropertyEntry[]
}>()
</script>

<style lang="scss" scoped>
.sim-line-separated-list {
    @include sim-text-small;
    color: $sim-c-basic-600;

    position: relative;
    padding-right: 1rem;

    &:not(:last-child)::after {
        position: absolute;
        content: "";
        right: 0.5rem;
        top: 0.2rem;
        height: 0.8125rem;
        width: 0.0625rem;
        background-color: $sim-c-basic-600;
    }
}
</style>
